'use strict';

import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import PopupAlert from '../components/PopupAlert';
import Card from '../react/agenda/components/AgendaContent/Card';

import { getCookie, setCookie } from '../react/agenda/utils/helpers';
// import { updateCookieWishlist as UpdateWishList } from '../components/Favourites';

function fetchAccountData(auth_id,contact_id) {
	if (!auth_id || auth_id === '') {
      return Promise.resolve({});
   }
	let wishlistUrl = '/tm-account/' + auth_id + '/?tm_session=' + contact_id;

	if ( 'undefined' != typeof document.documentElement.lang && document.documentElement.lang === 'en-EN') {
		wishlistUrl = '/en/tm-account/' + auth_id + '/?tm_session=' + contact_id;
	}

	return fetch(wishlistUrl)
		 .then(response => {
			  if (!response.ok) {
					throw new Error(`HTTP error! status: ${response.status}`);
			  }
			  return response.json();
		 })
		 .catch(error => {
			  console.error('Error fetching wishlist data:', error);
			  return {}; // Return an empty object if fetch fails
		 });
}

document.querySelectorAll('#wishlist').forEach((el) => {
	if ( 1 == parseInt(customData?.debug) ) {
		console.log('Checking wishlist...');
	}

	// match login cookie
	let match = document.cookie.match(new RegExp('(^| )' + ( customData?.cookieContactId ?? null ) + '=([^;]+)'));
	match = null === match ? '' : match[2];
	let isLoggedIn = match ? true : false;
	let customValues = '';
	let search = window.location.search;

	const clearList = document.querySelector('.wishlist__clear-result-content');
	const shareList = document.querySelector('.wishlist__share-content');

	// only show message when not logged in
	document.querySelectorAll('.wishlist__message').forEach((el) => {
		if ( String(el.dataset.logged_in) === String(isLoggedIn) ) {
			el.style.display = 'flex';
		} else {
			el.style.display = 'none';
		}
	})

	document.querySelectorAll('.js-popup-alert').forEach((el) => {
		new PopupAlert(el);
	})

	if ( search.indexOf('?ids=') > -1 && search.replace('?ids=','')!='') {
		if ( 1 == parseInt(customData?.debug) ) {
			console.log('Generate wishlist detected...');
		}
		customValues = search.replace('?ids=','').split(',');
		loadWishlist();
	} else {
		loadWishlist();
	}

	function shareWishlist(form) {
		if (!window.XMLHttpRequest) {
			return;
		}

		try {
			var xhr = new XMLHttpRequest();
			xhr.previous_text = '';
			xhr.responseType = "json";

			xhr.onerror = function() {
				console.log('XHR error');
			}
			xhr.onreadystatechange = function() {
				try {

					if (this.readyState == 4 && this.status == 200) {
						if (this.response.errors) {
							shareList.querySelector('.popup-alert__error').innerHTML = this.response.html;
						} else {
							shareList.querySelectorAll('input').forEach((el) => {
								el.style.display = 'none';
							})
							shareList.querySelector('button').style.display = 'none';
							shareList.querySelector('.popup-alert__error').innerHTML = this.response.html;
							setTimeout(function() {
								form.target.reset();
								shareList.querySelector('.popup-alert__error').innerHTML = '';
								shareList.querySelectorAll('input').forEach((el) => {
									el.removeAttribute('style');
								})
								shareList.querySelector('button').removeAttribute('style');
							}, 5000);
						}
					}

				} catch (e) {
					console.log(e);
				}
			}

			let formdata = new FormData(form.target);
			let params = '';
			params += '&name_from=' + encodeURIComponent( formdata.get('name_from') ?? '' );
			params += '&email_from=' + encodeURIComponent( formdata.get('email_from') ?? '' );
			params += '&email_to=' + encodeURIComponent( formdata.get('email_to') ?? '' );

			xhr.open('POST', customData.ajaxUrl, true);
			xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
			xhr.send('action=share_wishlist' + params);
		} catch (e) {
			console.log('XHR failed request');
		}
	}

	function loadWishlist() {
		if (!window.XMLHttpRequest) {
			return;
		}

		try {
			const tmAuthCookie = getCookie('tm_auth') || '';
			const tmSessionCookie = getCookie('tm_session') || '';

			fetchAccountData(tmAuthCookie,tmSessionCookie)
            .then(accountData => {

               // console.log('Account data:', accountData);

					var xhr = new XMLHttpRequest();
					xhr.previous_text = '';
					xhr.responseType = "json";

					xhr.onerror = function() {
						console.log('XHR error');
					}
					xhr.onreadystatechange = function() {
						try {
							if (this.readyState == 4 && this.status == 200) {
								el.innerHTML = this.response.html;

								if (el.contains(document.querySelector('.js_react_tile'))) {
									const cards = Array.from(el.querySelectorAll('.js_react_tile')).map((tile, index) => {
										const event = Object.values(JSON.parse(decodeURIComponent(tile.dataset.event)))[0];
										const show_button = tile.dataset.button;

										// If accountData is not empty object:
										if (Object.keys(accountData).length > 0) {

											const post_id = String(event.post_id);

											// If post_id exists in accountData:
											if (accountData[post_id]) {

												// If friendsale is true:
												if (accountData[post_id].friend_sale) {

													// If presale is lower than now:
													const presale = accountData[post_id].presale;
													var tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
													var localISOTime = (new Date(Date.now() - tzoffset)).toISOString();
													const now = localISOTime.slice(0, 16).replace(/[-T:]/g, ''); // Get current time in "YYYYMMDDHHMM"

													if (parseInt(presale) < parseInt(now)) {
														//Show ticket button with presale link:
														let ticketLink = accountData[post_id].ticket_link.replace('{tm_session}', tmSessionCookie);
														event.times[0].status_label = customData.i18n?.agenda_presale_status || 'Tickets';
														event.times[0].available = true;
														event.times[0].ticket_link = ticketLink;
													} else {
														// Change status label in button:
														const result = accountData[post_id].status_label;
														event.times[0].status_label = result;
													}
												}
											}
										}

										return (
											<Card
												key={index}
												show_button={show_button}
												animationDelay={{ '--animation-delay': `${(index < 4 ? index + 1 : 4) * 100}ms` }}
												{...event}
											/>
										);
									});

									const Wrapper = () => {
										const favouritesCookie = getCookie('mge_wishlist');
										const favouritesCookieArray = favouritesCookie ? decodeURIComponent(favouritesCookie).split(',').map(Number) : [];

										const [allFavourites, setAllFavourites] = useState(favouritesCookieArray);

										const emptyWishlist = () => {
											setAllFavourites([-1]);
											window.location.reload();
										};

										useEffect(() => {
											setCookie('mge_wishlist', allFavourites.join(','), 7);

										}, [allFavourites]);

										return (
											<>
												<button className="wishlist-list__empty btn btn--secondary" onClick={emptyWishlist}>{customData.i18n.agenda_favourites_empty}</button>
												<ul className="wishlist-list__tiles">
													{React.Children.map(cards, child => {
														return React.cloneElement(child, { allFavourites });
													})}
												</ul>
											</>
										)
									};

									ReactDOM.render(<Wrapper />, document.querySelector('.js-wishlist-list'));

								}
							}
						} catch (e) {
							console.log(e);
						}
					}
					let params = '&paged=' + (el.dataset.paged ?? 0);
					if ( customValues.length > 0 ) {
						params += '&ids=' + customValues.join(',');
					}
					if ( 'undefined' != typeof document.documentElement.lang ) {
						let lang = document.documentElement.lang;
						if ( lang.length > 2 ) {
							lang = lang.substring(0,2).toLowerCase();
						}
						params += '&lang=' + lang;
					}
					xhr.open('POST', customData.ajaxUrl, true);
					xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
					xhr.send('action=get_wishlist' + params);
				})
			.catch(error => {
					console.error('Failed to load wishlist due to account data fetch error:', error);
			});

		} catch (e) {
			console.log('XHR failed request');
		}
	}
})
